import { Inject } from 'inversify-props'
import type { MonitoramentoBancoServiceAdapter } from './adapter'
import { DatasourceStatus } from '@/api/monitoramento-banco'

export class FindMonitoramentoBancoUseCase {
  @Inject('MonitoramentoBancoServiceAdapter')
  private service!: MonitoramentoBancoServiceAdapter

	findStatus = (): Promise<DatasourceStatus> =>
		this.service.findStatus()
}
